(ns
  frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.financial-statements
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))


(defn financial-statements
  [{:keys [report-data] :as props}]
  {:consolidated-income-statement   (report-ctl/with-footnote
                                     props
                                     :consolidated-income-statement-footnotes
                                     (:group-income-statement report-data))
   :statement-of-financial-position (report-ctl/with-footnote
                                     props
                                     :statement-of-financial-position-footnotes
                                     (get-in report-data [:statement-of-financial-position]))})
